// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-report-container {
  background: white;
  color: #333;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  max-width: 210mm;
  margin: 0 auto;
  padding: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}
@media print {
  .pdf-report-container {
    box-shadow: none;
    padding: 15px;
    max-width: none;
    width: 100%;
  }
}
.pdf-report-container h1,
.pdf-report-container h2,
.pdf-report-container h3,
.pdf-report-container h4,
.pdf-report-container h5,
.pdf-report-container h6 {
  margin: 0 0 15px 0;
  font-weight: 600;
  color: #2c3e50;
}
.pdf-report-container h1 {
  font-size: 28px;
}
.pdf-report-container h2 {
  font-size: 22px;
}
.pdf-report-container h3 {
  font-size: 18px;
}
.pdf-report-container p {
  margin: 0 0 10px 0;
  font-size: 14px;
}
.pdf-report-container .pdf-header {
  border-bottom: 3px solid #3498db;
  padding-bottom: 20px;
  margin-bottom: 30px;
}
.pdf-report-container .pdf-header .header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}
.pdf-report-container .pdf-header .header-content .logo-section .logo-container {
  display: flex;
  align-items: center;
  gap: 10px;
}
.pdf-report-container .pdf-header .header-content .logo-section .logo-container .header-logo {
  width: 30px;
  height: 30px;
  object-fit: contain;
}
.pdf-report-container .pdf-header .header-content .logo-section .logo-container .logo-text {
  font-size: 28px;
  font-weight: bold;
  color: #000;
  letter-spacing: 1px;
}
.pdf-report-container .pdf-header .header-content .logo-section .logo-subtitle {
  font-size: 12px;
  color: #7f8c8d;
  margin-top: 5px;
  font-style: italic;
}
.pdf-report-container .pdf-header .header-content .report-info {
  text-align: right;
}
.pdf-report-container .pdf-header .header-content .report-info .report-title {
  color: #2c3e50;
  margin-bottom: 5px;
}
.pdf-report-container .pdf-header .header-content .report-info .report-date {
  font-size: 14px;
  color: #7f8c8d;
  font-style: italic;
}
.pdf-report-container .section-title {
  font-size: 18px;
  color: #2c3e50;
  border-left: 4px solid #3498db;
  padding-left: 12px;
  margin: 25px 0 15px 0;
  background: linear-gradient(90deg, #f8f9fa 0%, transparent 100%);
  padding: 8px 12px;
  border-radius: 0 5px 5px 0;
}
.pdf-report-container .student-info-section {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
}
.pdf-report-container .student-info-section .info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px;
}
.pdf-report-container .student-info-section .info-grid .info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: white;
  border-radius: 4px;
  border-left: 2px solid #3498db;
}
.pdf-report-container .student-info-section .info-grid .info-item label {
  font-weight: 600;
  color: #2c3e50;
  font-size: 12px;
}
.pdf-report-container .student-info-section .info-grid .info-item span {
  color: #34495e;
  font-weight: 500;
  font-size: 12px;
}
.pdf-report-container .performance-summary-section {
  margin-bottom: 30px;
}
.pdf-report-container .performance-summary-section .summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 20px;
}
.pdf-report-container .performance-summary-section .summary-cards .summary-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.pdf-report-container .performance-summary-section .summary-cards .summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
.pdf-report-container .performance-summary-section .summary-cards .summary-card.primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
}
.pdf-report-container .performance-summary-section .summary-cards .summary-card.primary .card-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pdf-report-container .performance-summary-section .summary-cards .summary-card.primary .accuracy-display {
  text-align: center;
}
.pdf-report-container .performance-summary-section .summary-cards .summary-card.primary .accuracy-display .accuracy-percentage {
  font-size: 48px;
  font-weight: bold;
  line-height: 1;
}
.pdf-report-container .performance-summary-section .summary-cards .summary-card.primary .accuracy-display .accuracy-label {
  font-size: 14px;
  opacity: 0.9;
  margin-top: 5px;
}
.pdf-report-container .performance-summary-section .summary-cards .summary-card .card-icon {
  font-size: 32px;
  margin-bottom: 10px;
}
.pdf-report-container .performance-summary-section .summary-cards .summary-card .card-value {
  font-size: 28px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}
.pdf-report-container .performance-summary-section .summary-cards .summary-card .card-label {
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 500;
}
.pdf-report-container .full-length-exams-section {
  margin-bottom: 30px;
}
.pdf-report-container .full-length-exams-section .summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 20px;
}
.pdf-report-container .full-length-exams-section .summary-cards .summary-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.pdf-report-container .full-length-exams-section .summary-cards .summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
.pdf-report-container .full-length-exams-section .summary-cards .summary-card .card-icon {
  font-size: 32px;
  margin-bottom: 10px;
}
.pdf-report-container .full-length-exams-section .summary-cards .summary-card .card-value {
  font-size: 28px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}
.pdf-report-container .full-length-exams-section .summary-cards .summary-card .card-label {
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 500;
}
.pdf-report-container .topic-mastery-section {
  margin-bottom: 30px;
}
.pdf-report-container .topic-mastery-section .summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 20px;
}
.pdf-report-container .topic-mastery-section .summary-cards .summary-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.pdf-report-container .topic-mastery-section .summary-cards .summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
.pdf-report-container .topic-mastery-section .summary-cards .summary-card .card-icon {
  font-size: 32px;
  margin-bottom: 10px;
}
.pdf-report-container .topic-mastery-section .summary-cards .summary-card .card-value {
  font-size: 28px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}
.pdf-report-container .topic-mastery-section .summary-cards .summary-card .card-label {
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 500;
}
.pdf-report-container .latest-scores-section {
  margin-top: 25px;
}
.pdf-report-container .latest-scores-section .subsection-title {
  font-size: 16px;
  color: #2c3e50;
  border-left: 3px solid #3498db;
  padding-left: 10px;
  margin: 20px 0 15px 0;
  background: linear-gradient(90deg, #f8f9fa 0%, transparent 100%);
  padding: 6px 10px;
  border-radius: 0 5px 5px 0;
}
.pdf-report-container .latest-scores-section .score-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
  margin-top: 15px;
}
.pdf-report-container .latest-scores-section .score-cards .score-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.pdf-report-container .latest-scores-section .score-cards .score-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-icon {
  font-size: 24px;
  margin-bottom: 8px;
  text-align: center;
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .score-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
  text-align: center;
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .score-values {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .score-values .latest-score,
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .score-values .initial-score {
  text-align: center;
  flex: 1 1;
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .score-values .latest-score .score-value,
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .score-values .initial-score .score-value {
  display: block;
  font-size: 20px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 2px;
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .score-values .latest-score .score-label-small,
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .score-values .initial-score .score-label-small {
  font-size: 10px;
  color: #7f8c8d;
  font-weight: 500;
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .score-values .latest-score .score-value {
  color: #27ae60;
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .score-values .initial-score .score-value {
  color: #e74c3c;
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .progress-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 8px;
  padding: 4px 8px;
  background: #f8f9fa;
  border-radius: 4px;
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .progress-indicator .trend {
  font-size: 14px;
  font-weight: bold;
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .progress-indicator .trend.up {
  color: #27ae60;
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .progress-indicator .trend.down {
  color: #e74c3c;
}
.pdf-report-container .latest-scores-section .score-cards .score-card .score-content .progress-indicator .progress-value {
  font-size: 11px;
  color: #7f8c8d;
  font-weight: 500;
}
.pdf-report-container .attempts-list-section {
  margin-top: 25px;
}
.pdf-report-container .attempts-list-section .attempts-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.pdf-report-container .attempts-list-section .attempts-table .table-header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  background: #34495e;
  color: white;
  font-weight: 600;
  font-size: 14px;
}
.pdf-report-container .attempts-list-section .attempts-table .table-header .header-cell {
  padding: 12px 10px;
  text-align: center;
  border-right: 1px solid #2c3e50;
}
.pdf-report-container .attempts-list-section .attempts-table .table-header .header-cell:last-child {
  border-right: none;
}
.pdf-report-container .attempts-list-section .attempts-table .table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.2s ease;
}
.pdf-report-container .attempts-list-section .attempts-table .table-row:hover {
  background-color: #f8f9fa;
}
.pdf-report-container .attempts-list-section .attempts-table .table-row:last-child {
  border-bottom: none;
}
.pdf-report-container .attempts-list-section .attempts-table .table-row .table-cell {
  padding: 10px 8px;
  text-align: center;
  font-size: 13px;
  border-right: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pdf-report-container .attempts-list-section .attempts-table .table-row .table-cell:last-child {
  border-right: none;
}
.pdf-report-container .attempts-list-section .attempts-table .table-row .table-cell.score {
  font-weight: 600;
}
.pdf-report-container .attempts-list-section .attempts-table .table-row .table-cell.overall-score {
  font-weight: bold;
  color: #3498db;
  font-size: 14px;
}
.pdf-report-container .no-data-message {
  text-align: center;
  padding: 40px 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;
  margin: 20px 0;
}
.pdf-report-container .no-data-message .no-data-icon {
  font-size: 48px;
  margin-bottom: 15px;
  opacity: 0.6;
}
.pdf-report-container .no-data-message .no-data-text {
  font-size: 16px;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 8px;
}
.pdf-report-container .no-data-message .no-data-subtext {
  font-size: 14px;
  color: #adb5bd;
  font-style: italic;
  line-height: 1.4;
}
.pdf-report-container .topic-performance-section {
  margin-bottom: 30px;
}
.pdf-report-container .topic-performance-section .performance-summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 20px;
}
.pdf-report-container .topic-performance-section .performance-summary-cards .summary-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.pdf-report-container .topic-performance-section .performance-summary-cards .summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
.pdf-report-container .topic-performance-section .performance-summary-cards .summary-card .card-icon {
  font-size: 32px;
  margin-bottom: 10px;
}
.pdf-report-container .topic-performance-section .performance-summary-cards .summary-card .card-value {
  font-size: 28px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}
.pdf-report-container .topic-performance-section .performance-summary-cards .summary-card .card-label {
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 500;
  margin-bottom: 5px;
}
.pdf-report-container .topic-performance-section .performance-summary-cards .summary-card .card-subtitle {
  font-size: 11px;
  color: #95a5a6;
  font-style: italic;
  line-height: 1.3;
}
.pdf-report-container .topic-performance-section .performance-summary-cards .no-data-message {
  grid-column: 1/-1;
  text-align: center;
  padding: 40px;
  color: #7f8c8d;
  font-style: italic;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px dashed #dee2e6;
}
.pdf-report-container .topic-performance-section .topic-scores-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.pdf-report-container .topic-performance-section .topic-scores-table .table-header {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr 1fr 1fr;
  background: #34495e;
  color: white;
  font-weight: 600;
  font-size: 14px;
}
.pdf-report-container .topic-performance-section .topic-scores-table .table-header .header-cell {
  padding: 15px 10px;
  text-align: center;
  border-right: 1px solid #2c3e50;
}
.pdf-report-container .topic-performance-section .topic-scores-table .table-header .header-cell:last-child {
  border-right: none;
}
.pdf-report-container .topic-performance-section .topic-scores-table .table-row {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr 1fr 1fr;
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.2s ease;
}
.pdf-report-container .topic-performance-section .topic-scores-table .table-row:hover {
  background-color: #f8f9fa;
}
.pdf-report-container .topic-performance-section .topic-scores-table .table-row:last-child {
  border-bottom: none;
}
.pdf-report-container .topic-performance-section .topic-scores-table .table-row .table-cell {
  padding: 12px 10px;
  text-align: center;
  font-size: 14px;
  border-right: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pdf-report-container .topic-performance-section .topic-scores-table .table-row .table-cell:last-child {
  border-right: none;
}
.pdf-report-container .topic-performance-section .topic-scores-table .table-row .table-cell.score {
  font-weight: 600;
}
.pdf-report-container .topic-performance-section .topic-scores-table .table-row .table-cell.overall-score {
  font-weight: bold;
  color: #3498db;
  font-size: 16px;
}
.pdf-report-container .topic-completion-section {
  margin-bottom: 30px;
}
.pdf-report-container .topic-completion-section .completion-chart {
  background: white;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.pdf-report-container .topic-completion-section .completion-chart .completion-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 15px;
}
.pdf-report-container .topic-completion-section .completion-chart .completion-item:last-child {
  margin-bottom: 0;
}
.pdf-report-container .topic-completion-section .completion-chart .completion-item .topic-name {
  flex: 1 1;
  font-weight: 500;
  font-size: 14px;
  color: #2c3e50;
}
.pdf-report-container .topic-completion-section .completion-chart .completion-item .progress-bar {
  flex: 2 1;
  height: 12px;
  background: #ecf0f1;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}
.pdf-report-container .topic-completion-section .completion-chart .completion-item .progress-bar .progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3498db, #2980b9);
  border-radius: 6px;
  transition: width 0.3s ease;
}
.pdf-report-container .topic-completion-section .completion-chart .completion-item .completion-percentage {
  min-width: 50px;
  text-align: right;
  font-weight: 600;
  color: #3498db;
  font-size: 14px;
}
.pdf-report-container .attendance-section {
  margin-bottom: 30px;
}
.pdf-report-container .attendance-section .attendance-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
  margin-top: 20px;
}
.pdf-report-container .attendance-section .attendance-summary .attendance-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
}
.pdf-report-container .attendance-section .attendance-summary .attendance-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
.pdf-report-container .attendance-section .attendance-summary .attendance-card.attended {
  border-color: #27ae60;
}
.pdf-report-container .attendance-section .attendance-summary .attendance-card.attended .attendance-icon {
  color: #27ae60;
}
.pdf-report-container .attendance-section .attendance-summary .attendance-card.missed {
  border-color: #e74c3c;
}
.pdf-report-container .attendance-section .attendance-summary .attendance-card.missed .attendance-icon {
  color: #e74c3c;
}
.pdf-report-container .attendance-section .attendance-summary .attendance-card.total {
  border-color: #3498db;
}
.pdf-report-container .attendance-section .attendance-summary .attendance-card.total .attendance-icon {
  color: #3498db;
}
.pdf-report-container .attendance-section .attendance-summary .attendance-card .attendance-icon {
  font-size: 32px;
  margin-bottom: 10px;
}
.pdf-report-container .attendance-section .attendance-summary .attendance-card .attendance-count {
  font-size: 28px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}
.pdf-report-container .attendance-section .attendance-summary .attendance-card .attendance-label {
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 500;
}
.pdf-report-container .recent-activity-section {
  margin-bottom: 30px;
}
.pdf-report-container .recent-activity-section .activity-list {
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}
.pdf-report-container .recent-activity-section .activity-list .activity-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.2s ease;
}
.pdf-report-container .recent-activity-section .activity-list .activity-item:hover {
  background-color: #f8f9fa;
}
.pdf-report-container .recent-activity-section .activity-list .activity-item:last-child {
  border-bottom: none;
}
.pdf-report-container .recent-activity-section .activity-list .activity-item .activity-icon {
  font-size: 24px;
  margin-right: 15px;
  color: #3498db;
}
.pdf-report-container .recent-activity-section .activity-list .activity-item .activity-details {
  flex: 1 1;
}
.pdf-report-container .recent-activity-section .activity-list .activity-item .activity-details .activity-title {
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
  margin-bottom: 3px;
}
.pdf-report-container .recent-activity-section .activity-list .activity-item .activity-details .activity-score {
  font-size: 12px;
  color: #7f8c8d;
}
.pdf-report-container .recent-activity-section .activity-list .activity-item .activity-date {
  font-size: 12px;
  color: #95a5a6;
  font-style: italic;
}
.pdf-report-container .feedback-section {
  margin-bottom: 30px;
}
.pdf-report-container .feedback-section .feedback-content {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #3498db;
}
.pdf-report-container .feedback-section .feedback-content .feedback-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.pdf-report-container .feedback-section .feedback-content .feedback-item:last-child {
  margin-bottom: 0;
}
.pdf-report-container .feedback-section .feedback-content .feedback-item .feedback-bullet {
  color: #3498db;
  font-weight: bold;
  margin-right: 10px;
  font-size: 16px;
  line-height: 1.4;
}
.pdf-report-container .feedback-section .feedback-content .feedback-item .feedback-text {
  flex: 1 1;
  font-size: 14px;
  color: #2c3e50;
  line-height: 1.5;
}
.pdf-report-container .learning-tips-section {
  margin-bottom: 30px;
}
.pdf-report-container .learning-tips-section .tips-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}
.pdf-report-container .learning-tips-section .tips-grid .tip-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  padding: 20px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.pdf-report-container .learning-tips-section .tips-grid .tip-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-color: #3498db;
}
.pdf-report-container .learning-tips-section .tips-grid .tip-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #3498db, #2980b9);
}
.pdf-report-container .learning-tips-section .tips-grid .tip-card .tip-icon {
  font-size: 24px;
  margin-bottom: 10px;
  color: #f39c12;
}
.pdf-report-container .learning-tips-section .tips-grid .tip-card .tip-text {
  font-size: 14px;
  color: #2c3e50;
  line-height: 1.5;
  font-weight: 500;
}
.pdf-report-container .pdf-footer {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 2px solid #e9ecef;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}
.pdf-report-container .pdf-footer .footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}
.pdf-report-container .pdf-footer .footer-content .footer-left .footer-logo-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
}
.pdf-report-container .pdf-footer .footer-content .footer-left .footer-logo-container .footer-logo-img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.pdf-report-container .pdf-footer .footer-content .footer-left .footer-logo-container .footer-logo-text {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.pdf-report-container .pdf-footer .footer-content .footer-left .footer-tagline {
  font-size: 12px;
  color: #7f8c8d;
  font-style: italic;
}
.pdf-report-container .pdf-footer .footer-content .footer-right {
  text-align: right;
}
.pdf-report-container .pdf-footer .footer-content .footer-right .footer-date {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 500;
  margin-bottom: 5px;
}
.pdf-report-container .pdf-footer .footer-content .footer-right .footer-note {
  font-size: 11px;
  color: #95a5a6;
  font-style: italic;
}
.pdf-report-container .subject-performance-section {
  margin-top: 40px;
}
.pdf-report-container .subject-performance-section .subject-performance-table {
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  margin-top: 20px;
}
.pdf-report-container .subject-performance-section .subject-performance-table .table-header,
.pdf-report-container .subject-performance-section .subject-performance-table .table-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  font-size: 14px;
}
.pdf-report-container .subject-performance-section .subject-performance-table .table-header {
  background: #34495e;
  color: white;
  font-weight: 600;
}
.pdf-report-container .subject-performance-section .subject-performance-table .table-header .header-cell {
  padding: 12px 10px;
  text-align: center;
}
.pdf-report-container .subject-performance-section .subject-performance-table .table-row {
  border-bottom: 1px solid #e9ecef;
}
.pdf-report-container .subject-performance-section .subject-performance-table .table-row .table-cell {
  padding: 10px 8px;
  text-align: center;
}
@media (max-width: 768px) {
  .pdf-report-container {
    padding: 15px;
  }
  .pdf-report-container .pdf-header .header-content {
    flex-direction: column;
    text-align: center;
  }
  .pdf-report-container .pdf-header .header-content .report-info {
    text-align: center;
  }
  .pdf-report-container .summary-cards {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
  .pdf-report-container .topic-scores-table .table-header,
  .pdf-report-container .topic-scores-table .table-row {
    grid-template-columns: 1fr;
    gap: 5px;
  }
  .pdf-report-container .topic-scores-table .table-header .header-cell,
  .pdf-report-container .topic-scores-table .table-header .table-cell,
  .pdf-report-container .topic-scores-table .table-row .header-cell,
  .pdf-report-container .topic-scores-table .table-row .table-cell {
    border-right: none;
    border-bottom: 1px solid #e9ecef;
    padding: 8px 5px;
    font-size: 12px;
  }
  .pdf-report-container .attendance-summary {
    grid-template-columns: 1fr;
  }
  .pdf-report-container .tips-grid {
    grid-template-columns: 1fr;
  }
  .pdf-report-container .pdf-footer .footer-content {
    flex-direction: column;
    text-align: center;
  }
  .pdf-report-container .pdf-footer .footer-content .footer-right {
    text-align: center;
  }
}
@media print {
  .pdf-report-container .pdf-report-container {
    box-shadow: none;
    padding: 0;
    margin: 0;
  }
  .pdf-report-container .summary-card:hover,
  .pdf-report-container .attendance-card:hover,
  .pdf-report-container .tip-card:hover {
    transform: none;
    box-shadow: none;
  }
  .pdf-report-container .section-title {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .pdf-report-container .topic-scores-table,
  .pdf-report-container .completion-chart,
  .pdf-report-container .activity-list {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .pdf-report-container .performance-summary-section,
  .pdf-report-container .topic-performance-section,
  .pdf-report-container .topic-completion-section,
  .pdf-report-container .attendance-section {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/Performance/PDFReport.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,WAAA;EACA,4DAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uCAAA;AAAF;AAGE;EAXF;IAYI,gBAAA;IACA,aAAA;IACA,eAAA;IACA,WAAA;EAAF;AACF;AAGE;;;;;;EAME,kBAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAIE;EACE,eAAA;AAFJ;AAIE;EACE,eAAA;AAFJ;AAKE;EACE,kBAAA;EACA,eAAA;AAHJ;AAOE;EACE,gCAAA;EACA,oBAAA;EACA,mBAAA;AALJ;AAOI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AALN;AAQQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AANV;AAQU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AANZ;AASU;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AAPZ;AAWQ;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AATV;AAaM;EACE,iBAAA;AAXR;AAaQ;EACE,cAAA;EACA,kBAAA;AAXV;AAcQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAZV;AAmBE;EACE,eAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;EACA,qBAAA;EACA,gEAAA;EACA,iBAAA;EACA,0BAAA;AAjBJ;AAqBE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAnBJ;AAqBI;EACE,aAAA;EACA,2DAAA;EACA,QAAA;AAnBN;AAqBM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;AAnBR;AAqBQ;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAnBV;AAsBQ;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AApBV;AA2BE;EACE,mBAAA;AAzBJ;AA2BI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AAzBN;AA2BM;EACE,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAzBR;AA2BQ;EACE,2BAAA;EACA,yCAAA;AAzBV;AA4BQ;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;AA1BV;AA4BU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA1BZ;AA6BU;EACE,kBAAA;AA3BZ;AA6BY;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AA3Bd;AA8BY;EACE,eAAA;EACA,YAAA;EACA,eAAA;AA5Bd;AAiCQ;EACE,eAAA;EACA,mBAAA;AA/BV;AAkCQ;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAhCV;AAmCQ;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAjCV;AAwCE;EACE,mBAAA;AAtCJ;AAwCI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AAtCN;AAwCM;EACE,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAtCR;AAwCQ;EACE,2BAAA;EACA,yCAAA;AAtCV;AAyCQ;EACE,eAAA;EACA,mBAAA;AAvCV;AA0CQ;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAxCV;AA2CQ;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAzCV;AAgDE;EACE,mBAAA;AA9CJ;AAgDI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AA9CN;AAgDM;EACE,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA9CR;AAgDQ;EACE,2BAAA;EACA,yCAAA;AA9CV;AAiDQ;EACE,eAAA;EACA,mBAAA;AA/CV;AAkDQ;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAhDV;AAmDQ;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAjDV;AAwDE;EACE,gBAAA;AAtDJ;AAwDI;EACE,eAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;EACA,qBAAA;EACA,gEAAA;EACA,iBAAA;EACA,0BAAA;AAtDN;AAyDI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AAvDN;AAyDM;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAvDR;AAyDQ;EACE,2BAAA;EACA,yCAAA;AAvDV;AA0DQ;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;AAxDV;AA4DU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AA1DZ;AA6DU;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;AA3DZ;AA6DY;;EAEE,kBAAA;EACA,SAAA;AA3Dd;AA6Dc;;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AA1DhB;AA6Dc;;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AA1DhB;AA+Dc;EACE,cAAA;AA7DhB;AAkEc;EACE,cAAA;AAhEhB;AAqEU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAnEZ;AAqEY;EACE,eAAA;EACA,iBAAA;AAnEd;AAqEc;EACE,cAAA;AAnEhB;AAsEc;EACE,cAAA;AApEhB;AAwEY;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAtEd;AA+EE;EACE,gBAAA;AA7EJ;AA+EI;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0CAAA;AA7EN;AA+EM;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA7ER;AA+EQ;EACE,kBAAA;EACA,kBAAA;EACA,+BAAA;AA7EV;AA+EU;EACE,kBAAA;AA7EZ;AAkFM;EACE,aAAA;EACA,0CAAA;EACA,gCAAA;EACA,sCAAA;AAhFR;AAkFQ;EACE,yBAAA;AAhFV;AAmFQ;EACE,mBAAA;AAjFV;AAoFQ;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlFV;AAoFU;EACE,kBAAA;AAlFZ;AAqFU;EACE,gBAAA;AAnFZ;AAsFU;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AApFZ;AA4FE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,cAAA;AA1FJ;AA4FI;EACE,eAAA;EACA,mBAAA;EACA,YAAA;AA1FN;AA6FI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA3FN;AA8FI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA5FN;AAiGE;EACE,mBAAA;AA/FJ;AAiGI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AA/FN;AAiGM;EACE,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA/FR;AAiGQ;EACE,2BAAA;EACA,yCAAA;AA/FV;AAkGQ;EACE,eAAA;EACA,mBAAA;AAhGV;AAmGQ;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAjGV;AAoGQ;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAlGV;AAqGQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAnGV;AAuGM;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;AArGR;AAyGI;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0CAAA;AAvGN;AAyGM;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAvGR;AAyGQ;EACE,kBAAA;EACA,kBAAA;EACA,+BAAA;AAvGV;AAyGU;EACE,kBAAA;AAvGZ;AA4GM;EACE,aAAA;EACA,0CAAA;EACA,gCAAA;EACA,sCAAA;AA1GR;AA4GQ;EACE,yBAAA;AA1GV;AA6GQ;EACE,mBAAA;AA3GV;AA8GQ;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA5GV;AA8GU;EACE,kBAAA;AA5GZ;AA+GU;EACE,gBAAA;AA7GZ;AAgHU;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AA9GZ;AAsHE;EACE,mBAAA;AApHJ;AAsHI;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AApHN;AAsHM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AApHR;AAsHQ;EACE,gBAAA;AApHV;AAuHQ;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AArHV;AAwHQ;EACE,SAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAtHV;AAwHU;EACE,YAAA;EACA,oDAAA;EACA,kBAAA;EACA,2BAAA;AAtHZ;AA0HQ;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAxHV;AA+HE;EACE,mBAAA;AA7HJ;AA+HI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AA7HN;AA+HM;EACE,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AA7HR;AA+HQ;EACE,2BAAA;EACA,yCAAA;AA7HV;AAgIQ;EACE,qBAAA;AA9HV;AA+HU;EACE,cAAA;AA7HZ;AAiIQ;EACE,qBAAA;AA/HV;AAgIU;EACE,cAAA;AA9HZ;AAkIQ;EACE,qBAAA;AAhIV;AAiIU;EACE,cAAA;AA/HZ;AAmIQ;EACE,eAAA;EACA,mBAAA;AAjIV;AAoIQ;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAlIV;AAqIQ;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAnIV;AA0IE;EACE,mBAAA;AAxIJ;AA0II;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAxIN;AA0IM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,sCAAA;AAxIR;AA0IQ;EACE,yBAAA;AAxIV;AA2IQ;EACE,mBAAA;AAzIV;AA4IQ;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AA1IV;AA6IQ;EACE,SAAA;AA3IV;AA6IU;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA3IZ;AA8IU;EACE,eAAA;EACA,cAAA;AA5IZ;AAgJQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AA9IV;AAqJE;EACE,mBAAA;AAnJJ;AAqJI;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;AAnJN;AAqJM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAnJR;AAqJQ;EACE,gBAAA;AAnJV;AAsJQ;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AApJV;AAuJQ;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AArJV;AA4JE;EACE,mBAAA;AA1JJ;AA4JI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AA1JN;AA4JM;EACE,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA1JR;AA4JQ;EACE,2BAAA;EACA,yCAAA;EACA,qBAAA;AA1JV;AA6JQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oDAAA;AA3JV;AA8JQ;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AA5JV;AA+JQ;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA7JV;AAoKE;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAlKJ;AAoKI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAlKN;AAqKQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAnKV;AAqKU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAnKZ;AAsKU;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AApKZ;AAwKQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAtKV;AA0KM;EACE,iBAAA;AAxKR;AA0KQ;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAxKV;AA2KQ;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAzKV;AAgLE;EACE,gBAAA;AA9KJ;AA+KI;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AA7KN;AA8KM;;EAEE,aAAA;EACA,0CAAA;EACA,eAAA;AA5KR;AA8KM;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;AA5KR;AA6KQ;EACE,kBAAA;EACA,kBAAA;AA3KV;AA8KM;EACE,gCAAA;AA5KR;AA6KQ;EACE,iBAAA;EACA,kBAAA;AA3KV;AAkLE;EAxgCF;IAygCI,aAAA;EA/KF;EAiLE;IACE,sBAAA;IACA,kBAAA;EA/KJ;EAiLI;IACE,kBAAA;EA/KN;EAmLE;IACE,2DAAA;EAjLJ;EAqLI;;IAEE,0BAAA;IACA,QAAA;EAnLN;EAqLM;;;;IAEE,kBAAA;IACA,gCAAA;IACA,gBAAA;IACA,eAAA;EAjLR;EAsLE;IACE,0BAAA;EApLJ;EAuLE;IACE,0BAAA;EArLJ;EAwLE;IACE,sBAAA;IACA,kBAAA;EAtLJ;EAwLI;IACE,kBAAA;EAtLN;AACF;AA2LE;EACE;IACE,gBAAA;IACA,UAAA;IACA,SAAA;EAzLJ;EA4LE;;;IAGE,eAAA;IACA,gBAAA;EA1LJ;EA6LE;IACE,wBAAA;IAAA,mBAAA;EA3LJ;EA8LE;;;IAGE,wBAAA;IAAA,mBAAA;EA5LJ;EAgME;;;;IAIE,wBAAA;IAAA,mBAAA;EA9LJ;AACF","sourcesContent":["// PDF Report Styles - Professional and Print-friendly\n.pdf-report-container {\n  background: white;\n  color: #333;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.6;\n  max-width: 210mm; // A4 width\n  margin: 0 auto;\n  padding: 20px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n\n  // Print styles\n  @media print {\n    box-shadow: none;\n    padding: 15px;\n    max-width: none;\n    width: 100%;\n  }\n\n  // Typography\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin: 0 0 15px 0;\n    font-weight: 600;\n    color: #2c3e50;\n  }\n\n  h1 {\n    font-size: 28px;\n  }\n  h2 {\n    font-size: 22px;\n  }\n  h3 {\n    font-size: 18px;\n  }\n\n  p {\n    margin: 0 0 10px 0;\n    font-size: 14px;\n  }\n\n  // Header Section\n  .pdf-header {\n    border-bottom: 3px solid #3498db;\n    padding-bottom: 20px;\n    margin-bottom: 30px;\n\n    .header-content {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex-wrap: wrap;\n      gap: 20px;\n\n      .logo-section {\n        .logo-container {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n\n          .header-logo {\n            width: 30px;\n            height: 30px;\n            object-fit: contain;\n          }\n\n          .logo-text {\n            font-size: 28px;\n            font-weight: bold;\n            color: #000;\n            letter-spacing: 1px;\n          }\n        }\n\n        .logo-subtitle {\n          font-size: 12px;\n          color: #7f8c8d;\n          margin-top: 5px;\n          font-style: italic;\n        }\n      }\n\n      .report-info {\n        text-align: right;\n\n        .report-title {\n          color: #2c3e50;\n          margin-bottom: 5px;\n        }\n\n        .report-date {\n          font-size: 14px;\n          color: #7f8c8d;\n          font-style: italic;\n        }\n      }\n    }\n  }\n\n  // Section Titles\n  .section-title {\n    font-size: 18px;\n    color: #2c3e50;\n    border-left: 4px solid #3498db;\n    padding-left: 12px;\n    margin: 25px 0 15px 0;\n    background: linear-gradient(90deg, #f8f9fa 0%, transparent 100%);\n    padding: 8px 12px;\n    border-radius: 0 5px 5px 0;\n  }\n\n  // Student Information Section\n  .student-info-section {\n    background: #f8f9fa;\n    padding: 12px;\n    border-radius: 6px;\n    margin-bottom: 20px;\n    border: 1px solid #e9ecef;\n\n    .info-grid {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n      gap: 8px;\n\n      .info-item {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 6px 10px;\n        background: white;\n        border-radius: 4px;\n        border-left: 2px solid #3498db;\n\n        label {\n          font-weight: 600;\n          color: #2c3e50;\n          font-size: 12px;\n        }\n\n        span {\n          color: #34495e;\n          font-weight: 500;\n          font-size: 12px;\n        }\n      }\n    }\n  }\n\n  // Performance Summary Section\n  .performance-summary-section {\n    margin-bottom: 30px;\n\n    .summary-cards {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n      gap: 20px;\n      margin-top: 20px;\n\n      .summary-card {\n        background: white;\n        border: 2px solid #e9ecef;\n        border-radius: 10px;\n        padding: 20px;\n        text-align: center;\n        transition: all 0.3s ease;\n        position: relative;\n        overflow: hidden;\n\n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n        }\n\n        &.primary {\n          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n          color: white;\n          border-color: #667eea;\n\n          .card-content {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n          }\n\n          .accuracy-display {\n            text-align: center;\n\n            .accuracy-percentage {\n              font-size: 48px;\n              font-weight: bold;\n              line-height: 1;\n            }\n\n            .accuracy-label {\n              font-size: 14px;\n              opacity: 0.9;\n              margin-top: 5px;\n            }\n          }\n        }\n\n        .card-icon {\n          font-size: 32px;\n          margin-bottom: 10px;\n        }\n\n        .card-value {\n          font-size: 28px;\n          font-weight: bold;\n          color: #2c3e50;\n          margin-bottom: 5px;\n        }\n\n        .card-label {\n          font-size: 12px;\n          color: #7f8c8d;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  // Full Length Exams Section\n  .full-length-exams-section {\n    margin-bottom: 30px;\n\n    .summary-cards {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n      gap: 20px;\n      margin-top: 20px;\n\n      .summary-card {\n        background: white;\n        border: 2px solid #e9ecef;\n        border-radius: 10px;\n        padding: 20px;\n        text-align: center;\n        transition: all 0.3s ease;\n        position: relative;\n        overflow: hidden;\n\n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n        }\n\n        .card-icon {\n          font-size: 32px;\n          margin-bottom: 10px;\n        }\n\n        .card-value {\n          font-size: 28px;\n          font-weight: bold;\n          color: #2c3e50;\n          margin-bottom: 5px;\n        }\n\n        .card-label {\n          font-size: 12px;\n          color: #7f8c8d;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  // Topic Mastery Section\n  .topic-mastery-section {\n    margin-bottom: 30px;\n\n    .summary-cards {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n      gap: 20px;\n      margin-top: 20px;\n\n      .summary-card {\n        background: white;\n        border: 2px solid #e9ecef;\n        border-radius: 10px;\n        padding: 20px;\n        text-align: center;\n        transition: all 0.3s ease;\n        position: relative;\n        overflow: hidden;\n\n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n        }\n\n        .card-icon {\n          font-size: 32px;\n          margin-bottom: 10px;\n        }\n\n        .card-value {\n          font-size: 28px;\n          font-weight: bold;\n          color: #2c3e50;\n          margin-bottom: 5px;\n        }\n\n        .card-label {\n          font-size: 12px;\n          color: #7f8c8d;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  // Latest Scores Section\n  .latest-scores-section {\n    margin-top: 25px;\n\n    .subsection-title {\n      font-size: 16px;\n      color: #2c3e50;\n      border-left: 3px solid #3498db;\n      padding-left: 10px;\n      margin: 20px 0 15px 0;\n      background: linear-gradient(90deg, #f8f9fa 0%, transparent 100%);\n      padding: 6px 10px;\n      border-radius: 0 5px 5px 0;\n    }\n\n    .score-cards {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n      gap: 15px;\n      margin-top: 15px;\n\n      .score-card {\n        background: white;\n        border: 2px solid #e9ecef;\n        border-radius: 8px;\n        padding: 15px;\n        transition: all 0.3s ease;\n        position: relative;\n        overflow: hidden;\n\n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n        }\n\n        .score-icon {\n          font-size: 24px;\n          margin-bottom: 8px;\n          text-align: center;\n        }\n\n        .score-content {\n          .score-label {\n            display: block;\n            font-size: 14px;\n            font-weight: 600;\n            color: #2c3e50;\n            margin-bottom: 10px;\n            text-align: center;\n          }\n\n          .score-values {\n            display: flex;\n            justify-content: space-between;\n            margin-bottom: 8px;\n\n            .latest-score,\n            .initial-score {\n              text-align: center;\n              flex: 1;\n\n              .score-value {\n                display: block;\n                font-size: 20px;\n                font-weight: bold;\n                color: #2c3e50;\n                margin-bottom: 2px;\n              }\n\n              .score-label-small {\n                font-size: 10px;\n                color: #7f8c8d;\n                font-weight: 500;\n              }\n            }\n\n            .latest-score {\n              .score-value {\n                color: #27ae60;\n              }\n            }\n\n            .initial-score {\n              .score-value {\n                color: #e74c3c;\n              }\n            }\n          }\n\n          .progress-indicator {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 5px;\n            margin-top: 8px;\n            padding: 4px 8px;\n            background: #f8f9fa;\n            border-radius: 4px;\n\n            .trend {\n              font-size: 14px;\n              font-weight: bold;\n\n              &.up {\n                color: #27ae60;\n              }\n\n              &.down {\n                color: #e74c3c;\n              }\n            }\n\n            .progress-value {\n              font-size: 11px;\n              color: #7f8c8d;\n              font-weight: 500;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Attempts List Section\n  .attempts-list-section {\n    margin-top: 25px;\n\n    .attempts-table {\n      background: white;\n      border-radius: 8px;\n      overflow: hidden;\n      border: 1px solid #e9ecef;\n      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n\n      .table-header {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n        background: #34495e;\n        color: white;\n        font-weight: 600;\n        font-size: 14px;\n\n        .header-cell {\n          padding: 12px 10px;\n          text-align: center;\n          border-right: 1px solid #2c3e50;\n\n          &:last-child {\n            border-right: none;\n          }\n        }\n      }\n\n      .table-row {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n        border-bottom: 1px solid #e9ecef;\n        transition: background-color 0.2s ease;\n\n        &:hover {\n          background-color: #f8f9fa;\n        }\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        .table-cell {\n          padding: 10px 8px;\n          text-align: center;\n          font-size: 13px;\n          border-right: 1px solid #e9ecef;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          &:last-child {\n            border-right: none;\n          }\n\n          &.score {\n            font-weight: 600;\n          }\n\n          &.overall-score {\n            font-weight: bold;\n            color: #3498db;\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n\n  // No Data Message\n  .no-data-message {\n    text-align: center;\n    padding: 40px 20px;\n    background: #f8f9fa;\n    border-radius: 8px;\n    border: 2px dashed #dee2e6;\n    margin: 20px 0;\n\n    .no-data-icon {\n      font-size: 48px;\n      margin-bottom: 15px;\n      opacity: 0.6;\n    }\n\n    .no-data-text {\n      font-size: 16px;\n      font-weight: 600;\n      color: #6c757d;\n      margin-bottom: 8px;\n    }\n\n    .no-data-subtext {\n      font-size: 14px;\n      color: #adb5bd;\n      font-style: italic;\n      line-height: 1.4;\n    }\n  }\n\n  // Topic Performance Section\n  .topic-performance-section {\n    margin-bottom: 30px;\n\n    .performance-summary-cards {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n      gap: 20px;\n      margin-top: 20px;\n\n      .summary-card {\n        background: white;\n        border: 2px solid #e9ecef;\n        border-radius: 10px;\n        padding: 20px;\n        text-align: center;\n        transition: all 0.3s ease;\n        position: relative;\n        overflow: hidden;\n\n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n        }\n\n        .card-icon {\n          font-size: 32px;\n          margin-bottom: 10px;\n        }\n\n        .card-value {\n          font-size: 28px;\n          font-weight: bold;\n          color: #2c3e50;\n          margin-bottom: 5px;\n        }\n\n        .card-label {\n          font-size: 12px;\n          color: #7f8c8d;\n          font-weight: 500;\n          margin-bottom: 5px;\n        }\n\n        .card-subtitle {\n          font-size: 11px;\n          color: #95a5a6;\n          font-style: italic;\n          line-height: 1.3;\n        }\n      }\n\n      .no-data-message {\n        grid-column: 1 / -1;\n        text-align: center;\n        padding: 40px;\n        color: #7f8c8d;\n        font-style: italic;\n        background: #f8f9fa;\n        border-radius: 8px;\n        border: 1px dashed #dee2e6;\n      }\n    }\n\n    .topic-scores-table {\n      background: white;\n      border-radius: 8px;\n      overflow: hidden;\n      border: 1px solid #e9ecef;\n      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n\n      .table-header {\n        display: grid;\n        grid-template-columns: 2fr 2fr 1fr 1fr 1fr;\n        background: #34495e;\n        color: white;\n        font-weight: 600;\n        font-size: 14px;\n\n        .header-cell {\n          padding: 15px 10px;\n          text-align: center;\n          border-right: 1px solid #2c3e50;\n\n          &:last-child {\n            border-right: none;\n          }\n        }\n      }\n\n      .table-row {\n        display: grid;\n        grid-template-columns: 2fr 2fr 1fr 1fr 1fr;\n        border-bottom: 1px solid #e9ecef;\n        transition: background-color 0.2s ease;\n\n        &:hover {\n          background-color: #f8f9fa;\n        }\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        .table-cell {\n          padding: 12px 10px;\n          text-align: center;\n          font-size: 14px;\n          border-right: 1px solid #e9ecef;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          &:last-child {\n            border-right: none;\n          }\n\n          &.score {\n            font-weight: 600;\n          }\n\n          &.overall-score {\n            font-weight: bold;\n            color: #3498db;\n            font-size: 16px;\n          }\n        }\n      }\n    }\n  }\n\n  // Topic Completion Section\n  .topic-completion-section {\n    margin-bottom: 30px;\n\n    .completion-chart {\n      background: white;\n      padding: 20px;\n      border-radius: 8px;\n      border: 1px solid #e9ecef;\n\n      .completion-item {\n        display: flex;\n        align-items: center;\n        margin-bottom: 15px;\n        gap: 15px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n\n        .topic-name {\n          flex: 1;\n          font-weight: 500;\n          font-size: 14px;\n          color: #2c3e50;\n        }\n\n        .progress-bar {\n          flex: 2;\n          height: 12px;\n          background: #ecf0f1;\n          border-radius: 6px;\n          overflow: hidden;\n          position: relative;\n\n          .progress-fill {\n            height: 100%;\n            background: linear-gradient(90deg, #3498db, #2980b9);\n            border-radius: 6px;\n            transition: width 0.3s ease;\n          }\n        }\n\n        .completion-percentage {\n          min-width: 50px;\n          text-align: right;\n          font-weight: 600;\n          color: #3498db;\n          font-size: 14px;\n        }\n      }\n    }\n  }\n\n  // Attendance Section\n  .attendance-section {\n    margin-bottom: 30px;\n\n    .attendance-summary {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n      gap: 20px;\n      margin-top: 20px;\n\n      .attendance-card {\n        background: white;\n        border: 2px solid #e9ecef;\n        border-radius: 10px;\n        padding: 20px;\n        text-align: center;\n        transition: all 0.3s ease;\n\n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n        }\n\n        &.attended {\n          border-color: #27ae60;\n          .attendance-icon {\n            color: #27ae60;\n          }\n        }\n\n        &.missed {\n          border-color: #e74c3c;\n          .attendance-icon {\n            color: #e74c3c;\n          }\n        }\n\n        &.total {\n          border-color: #3498db;\n          .attendance-icon {\n            color: #3498db;\n          }\n        }\n\n        .attendance-icon {\n          font-size: 32px;\n          margin-bottom: 10px;\n        }\n\n        .attendance-count {\n          font-size: 28px;\n          font-weight: bold;\n          color: #2c3e50;\n          margin-bottom: 5px;\n        }\n\n        .attendance-label {\n          font-size: 12px;\n          color: #7f8c8d;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  // Recent Activity Section\n  .recent-activity-section {\n    margin-bottom: 30px;\n\n    .activity-list {\n      background: white;\n      border-radius: 8px;\n      border: 1px solid #e9ecef;\n      overflow: hidden;\n\n      .activity-item {\n        display: flex;\n        align-items: center;\n        padding: 15px 20px;\n        border-bottom: 1px solid #e9ecef;\n        transition: background-color 0.2s ease;\n\n        &:hover {\n          background-color: #f8f9fa;\n        }\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        .activity-icon {\n          font-size: 24px;\n          margin-right: 15px;\n          color: #3498db;\n        }\n\n        .activity-details {\n          flex: 1;\n\n          .activity-title {\n            font-weight: 600;\n            color: #2c3e50;\n            font-size: 14px;\n            margin-bottom: 3px;\n          }\n\n          .activity-score {\n            font-size: 12px;\n            color: #7f8c8d;\n          }\n        }\n\n        .activity-date {\n          font-size: 12px;\n          color: #95a5a6;\n          font-style: italic;\n        }\n      }\n    }\n  }\n\n  // Feedback Section\n  .feedback-section {\n    margin-bottom: 30px;\n\n    .feedback-content {\n      background: #f8f9fa;\n      padding: 20px;\n      border-radius: 8px;\n      border-left: 4px solid #3498db;\n\n      .feedback-item {\n        display: flex;\n        align-items: flex-start;\n        margin-bottom: 12px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n\n        .feedback-bullet {\n          color: #3498db;\n          font-weight: bold;\n          margin-right: 10px;\n          font-size: 16px;\n          line-height: 1.4;\n        }\n\n        .feedback-text {\n          flex: 1;\n          font-size: 14px;\n          color: #2c3e50;\n          line-height: 1.5;\n        }\n      }\n    }\n  }\n\n  // Learning Tips Section\n  .learning-tips-section {\n    margin-bottom: 30px;\n\n    .tips-grid {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n      gap: 20px;\n      margin-top: 20px;\n\n      .tip-card {\n        background: white;\n        border: 2px solid #e9ecef;\n        border-radius: 10px;\n        padding: 20px;\n        transition: all 0.3s ease;\n        position: relative;\n        overflow: hidden;\n\n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n          border-color: #3498db;\n        }\n\n        &::before {\n          content: \"\";\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          height: 3px;\n          background: linear-gradient(90deg, #3498db, #2980b9);\n        }\n\n        .tip-icon {\n          font-size: 24px;\n          margin-bottom: 10px;\n          color: #f39c12;\n        }\n\n        .tip-text {\n          font-size: 14px;\n          color: #2c3e50;\n          line-height: 1.5;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  // Footer\n  .pdf-footer {\n    margin-top: 40px;\n    padding-top: 20px;\n    border-top: 2px solid #e9ecef;\n    background: #f8f9fa;\n    padding: 20px;\n    border-radius: 8px;\n\n    .footer-content {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex-wrap: wrap;\n      gap: 20px;\n\n      .footer-left {\n        .footer-logo-container {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          margin-bottom: 5px;\n\n          .footer-logo-img {\n            width: 24px;\n            height: 24px;\n            object-fit: contain;\n          }\n\n          .footer-logo-text {\n            font-size: 18px;\n            font-weight: bold;\n            color: #000;\n          }\n        }\n\n        .footer-tagline {\n          font-size: 12px;\n          color: #7f8c8d;\n          font-style: italic;\n        }\n      }\n\n      .footer-right {\n        text-align: right;\n\n        .footer-date {\n          font-size: 14px;\n          color: #2c3e50;\n          font-weight: 500;\n          margin-bottom: 5px;\n        }\n\n        .footer-note {\n          font-size: 11px;\n          color: #95a5a6;\n          font-style: italic;\n        }\n      }\n    }\n  }\n\n  // Subject-wise Performance Section\n  .subject-performance-section {\n    margin-top: 40px;\n    .subject-performance-table {\n      background: white;\n      border-radius: 8px;\n      border: 1px solid #e9ecef;\n      margin-top: 20px;\n      .table-header,\n      .table-row {\n        display: grid;\n        grid-template-columns: 2fr 1fr 1fr 1fr 1fr;\n        font-size: 14px;\n      }\n      .table-header {\n        background: #34495e;\n        color: white;\n        font-weight: 600;\n        .header-cell {\n          padding: 12px 10px;\n          text-align: center;\n        }\n      }\n      .table-row {\n        border-bottom: 1px solid #e9ecef;\n        .table-cell {\n          padding: 10px 8px;\n          text-align: center;\n        }\n      }\n    }\n  }\n\n  // Responsive Design\n  @media (max-width: 768px) {\n    padding: 15px;\n\n    .pdf-header .header-content {\n      flex-direction: column;\n      text-align: center;\n\n      .report-info {\n        text-align: center;\n      }\n    }\n\n    .summary-cards {\n      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    }\n\n    .topic-scores-table {\n      .table-header,\n      .table-row {\n        grid-template-columns: 1fr;\n        gap: 5px;\n\n        .header-cell,\n        .table-cell {\n          border-right: none;\n          border-bottom: 1px solid #e9ecef;\n          padding: 8px 5px;\n          font-size: 12px;\n        }\n      }\n    }\n\n    .attendance-summary {\n      grid-template-columns: 1fr;\n    }\n\n    .tips-grid {\n      grid-template-columns: 1fr;\n    }\n\n    .pdf-footer .footer-content {\n      flex-direction: column;\n      text-align: center;\n\n      .footer-right {\n        text-align: center;\n      }\n    }\n  }\n\n  // Print-specific styles\n  @media print {\n    .pdf-report-container {\n      box-shadow: none;\n      padding: 0;\n      margin: 0;\n    }\n\n    .summary-card:hover,\n    .attendance-card:hover,\n    .tip-card:hover {\n      transform: none;\n      box-shadow: none;\n    }\n\n    .section-title {\n      break-inside: avoid;\n    }\n\n    .topic-scores-table,\n    .completion-chart,\n    .activity-list {\n      break-inside: avoid;\n    }\n\n    // Ensure page breaks don't occur in the middle of important sections\n    .performance-summary-section,\n    .topic-performance-section,\n    .topic-completion-section,\n    .attendance-section {\n      break-inside: avoid;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
